import { useState } from 'react';
import { string, bool } from 'prop-types';
import { Form, Checkbox } from 'antd';

import { useI18n } from 'context/i18n';
import { useValidate } from 'hooks';

import ProtectionDataModal from 'components/protectionDataModal';

import { IS_CAMPER, IS_NNORMAL } from 'utils/constants';
import { getMarket, getLang } from 'utils/helpers';

import styles from './style.module.css';

const PrivacyPolicy = ({
  origin, wrapperClass, checkBoxClass, hideConditions,
}) => {
  const { t, locale, profileData } = useI18n();
  const validate = useValidate();
  const [ dataModalVisible, setDataModalVisible ] = useState(false);

  const market = getMarket(locale);

  const classForCheckbox = checkBoxClass === undefined ? styles.privacyCheckbox : `${styles.privacyCheckbox} ${checkBoxClass}`;

  return (
    <>
      <Form.Item className={wrapperClass}>
        <div className={styles.privacyWrapper}>
          <p
            className={styles.infoLink}
            onClick={() => setDataModalVisible(true)}
          >
            {t('generico', IS_CAMPER ? 'camper.newsletter.proteccion.datos' : 'newsletter.proteccion.datos', 'Data protection information')}
          </p>
        </div>
      </Form.Item>
      <Form.Item name="privacy" valuePropName="checked" rules={validate('privacyPolicy')}>
        <Checkbox
          tabIndex="27"
          className={market !== 'TR' ? classForCheckbox : `${classForCheckbox} ${styles.withMargin}`}
        >
          <span className={styles.privacyAgreement}>
            {t('compra.formulario', 'acepto.las')}&nbsp;
            {
              !hideConditions && <>
                <a href={profileData.urlTermsAndConditions} target="_blank" rel="noreferrer">{t('compra.formulario', 'condiciones.generales')}</a>&nbsp;
                {t('compra.formulario', 'y.la')}&nbsp;
              </>
            }
            <a href={profileData.urlPrivacyPolicy} target="_blank" rel="noreferrer">{t('generico', 'privacy.conditions', 'privacy conditions')}</a>&nbsp;
            {t('compra.formulario', 'become.member')}
            {
              market === 'TR' &&
              <span>
                <br/>
                {t('compra.formulario', 'informacion.comercial.tr')}
              </span>
            }
          </span>
        </Checkbox>
      </Form.Item>
      <ProtectionDataModal
        visible={dataModalVisible}
        onCancel={() => setDataModalVisible(false)}
        origin={origin}
        />
    </>
  );
};

PrivacyPolicy.propTypes = {
  origin: string,
  wrapperClass: string,
  checkBoxClass: string,
  hideConditions: bool,
};

PrivacyPolicy.defaultProps = {
  origin: 'newsletter',
  wrapperClass: '',
  hideConditions: false,
};

export default PrivacyPolicy;
